var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import PropTypes from 'prop-types';
import VisibilitySensor from 'react-visibility-sensor';
import Dish from '../Dish/Dish';
import ImagesSliderModal from '../ImagesSliderModal';
import { slugify } from '../../app/general';
import iframeObserver from '../../utils/iframe-observer';
import { DISCOUNT_TYPES } from '../../order-fields';
import OtoAlertNew from '../../components/common/OtoAlertNew';
import { getDiscountRuleText } from '../Restaurant/RestaurantDiscountLabel';
import DiscountIcon from '../../icons/DiscountIcon';
var offset = { top: 200 };
var RestaurantMenuCategories = /** @class */ (function (_super) {
    __extends(RestaurantMenuCategories, _super);
    function RestaurantMenuCategories() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { imageModalDish: null };
        _this.openImageModal = function (dish) { return _this.setState({ imageModalDish: dish }); };
        _this.closeImageModal = function () { return _this.setState({ imageModalDish: null }); };
        _this.onVisibleCategoryChange = function (isVisible, category) {
            if (iframeObserver.hasParentIframe()) {
                console.warn('Restaurant menu- iframe detected, active category wont change on scroll');
                return;
            }
            if (isVisible) {
                _this.props.setActiveCategory(category);
            }
        };
        return _this;
    }
    RestaurantMenuCategories.prototype.render = function () {
        var _this = this;
        var _a = this.props, categories = _a.categories, addToCart = _a.addToCart, isDisabled = _a.isDisabled, discountRules = _a.discountRules, onPlace = _a.onPlace;
        var categoryRules = discountRules ? discountRules.filter(function (rule) { return rule.type === DISCOUNT_TYPES.SAME_CATEGORY; }) : [];
        var productRules = discountRules ? discountRules.filter(function (rule) { return rule.type === DISCOUNT_TYPES.SAME_PRODUCT; }) : [];
        return React.createElement(React.Fragment, null,
            categories && categories.map(function (category) {
                var currentCategoryRules = categoryRules && categoryRules.filter(function (rule) { return rule.categoryName === category.name; });
                return React.createElement(VisibilitySensor, { offset: offset, minTopValue: 150, key: category.name, onChange: function (isVisible) { return _this.onVisibleCategoryChange(isVisible, category); }, partialVisibility: true },
                    React.createElement("div", { className: "takeout-category" },
                        React.createElement("h2", { id: "category-".concat(slugify(category.name)), className: "takeout-category__title" }, category.name),
                        category.text ? React.createElement("div", { className: "w-100 text-center" },
                            React.createElement("div", { className: "takeout-category__text" }, category.text)) : null,
                        currentCategoryRules && currentCategoryRules.map(function (rule) { return React.createElement(OtoAlertNew, { key: getDiscountRuleText(rule), className: "my-2 justify-content-center w-100", color: "primary", closable: false, icon: React.createElement(DiscountIcon, null), withBorder: true }, getDiscountRuleText(rule)); }),
                        category.items && category.items.map(function (dish, index) { return (React.createElement(Dish, { key: "".concat(dish.name).concat(index), addToCart: onPlace ? null : addToCart, dish: dish, discountRule: productRules.find(function (rule) { return rule.productName === dish.name; }), fullWidth: true, isDisabled: isDisabled, openImageModal: _this.openImageModal })); })));
            }),
            this.renderImageModal());
    };
    RestaurantMenuCategories.prototype.renderImageModal = function () {
        var dish = this.state.imageModalDish;
        if (!dish) {
            return null;
        }
        return React.createElement(ImagesSliderModal, { images: [dish.image], title: dish.name, hasWebp: false, toggle: this.closeImageModal, imgClassName: "h-auto" });
    };
    RestaurantMenuCategories.propTypes = {
        addToCart: PropTypes.func,
        categories: PropTypes.array.isRequired,
        isDisabled: PropTypes.bool.isRequired,
        discountRules: PropTypes.array,
        onPlace: PropTypes.bool.isRequired,
        setActiveCategory: PropTypes.func.isRequired,
    };
    RestaurantMenuCategories.displayName = 'RestaurantMenuCategories';
    return RestaurantMenuCategories;
}(React.PureComponent));
export default RestaurantMenuCategories;
